import script from "./EScrollbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./EScrollbar.vue?vue&type=script&setup=true&lang=ts"

import "./EScrollbar.vue?vue&type=style&index=0&id=237ead39&lang=css"

const __exports__ = script;

export default __exports__